import {withRouter} from "react-router-dom";
import React, { useState, useEffect } from 'react';

import { Title } from 'root/admin/components';
import store from 'root/admin/store';
import {Form, Field, Loader, FileInput, Row} from '@smartplatform/ui';

import { observer } from 'mobx-react';
import { observable, action } from 'mobx';

@observer class BannerHome extends React.Component{

    @observable record = null;
    @observable error = null;
    @observable image = null;
    accepts_file = 'image/jpeg, image/png';

    constructor(props) {
        super(props);
        this.init();
    }

    init = async () => {
        this.error = null;
        try{
            const data = await store.model.BannerHome.find();
            if(data.length > 0){
                this.record = data[0];
                const pathImage = this.record.filename ? this.record?.downloadFile('filename') : false;
                this.image = pathImage;
            }else{
                this.record = new store.model.BannerHome();
            }
        }catch(err){
            this.error = err.message;
        }
    };

    onChange = (imageChange) => {
        if(imageChange){
            this.image = imageChange.preview;
            console.log(this.image);
        }
    }

    @action onDelete = (record) => {
        this.image = false;
    }

    render(){

        if (!this.record) {
            return <Loader />;
        }

        return(
            <div>
                {this.error && <div>{this.error}</div>}
                <Title name="Баннер под виджетом Гос. Услуг" />
                <Form record={this.record} rootPath="/admin" stay onSave={() => store.history.push(`/admin/banner-home`)}>
                    <Field property="show" label="Показывать баннер?" />
                    <Field property="link" label="Ссылка баннера" />
                    <Row>
                        <Field property="filename" label="Изображение баннера">
                            <FileInput accept={this.accepts_file} onChange={this.onChange} onDelete={this.onDelete} />
                        </Field>
                    </Row>
                    {this.image &&
                        <div className='wrapper-preview-banner'>
                            <img alt="img" style={{ width: '500px' }} src={this.image} />
                        </div>
                    }
                </Form>
            </div>
        );
    }
}

export default withRouter(BannerHome);